import {Component, OnDestroy, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {NzMessageService, NzModalService} from 'ng-zorro-antd';
// import {UploaderComponent} from '../../shared/uploader';
import {takeUntil} from 'rxjs/operators';
import {Subject, Subscription} from 'rxjs';
import {DistributorsService, RootService} from '../../../services';
import {NzNotificationService} from 'ng-zorro-antd/notification';

interface ItemData {
  id: number;
  name: string;
  age: number;
  address: string;
}

@Component({
  selector: 'distributor-detail',
  templateUrl: './distributor-detail.component.html',
  styleUrls: ['./distributor-detail.component.scss']
})
export class DistributorDetailComponent implements OnInit, OnDestroy {

  unsubscribe$ = new Subject<void>();

  pageIndex = 1;
  pageSize = 10;
  changeAction;
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  listOfDisplayData;
  listOfAllData: ItemData[] = [];
  mapOfCheckedId: { [key: string]: boolean } = {};
  // tslint:disable-next-line:variable-name
  loading = true;
  total: number;
  query;
  subscription: Subscription;
  viewDetail;
  data = [];
  listProduct;
  // @ts-ignore
  @ViewChild('addDistributors') addDistributors;
  // @ts-ignore
  @ViewChild('assignProduct') assignProduct;
  // @ts-ignore
  @ViewChild('modalDelete') modalDelete;
  // @ts-ignore
  @ViewChild('modal') modal;
  businessId;
  statusProduct;
  name: string;
  title;
  titleId;
  ids: any[] = [];
  imageFalse = [];

  constructor(
    private router: Router,
    private message: NzMessageService,
    private activatedRoute: ActivatedRoute,
    private distributorsService: DistributorsService,
    private notification: NzNotificationService,
    private rootService: RootService,
  ) {

  }

  ngOnInit(): void {


    this.subscription = this.activatedRoute.params.subscribe((params: Params) => {
      this.businessId = params.id;
      this.distributorsService.detailDistributor(params.id).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
        this.viewDetail = res.data;
        this.loadData();
      });
    });


    this.distributorsService.listTitle().pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.title = res.data;
    });
  }

  async loadData(ms = 0) {
    this.loading = true;
    this.query = {
      name: this.name ? this.name.trim() : '',
      titleId: this.titleId ? this.titleId : '',
      page: this.pageIndex,
      page_size: this.pageSize
    };
    await this.sleep(ms);
    this.distributorsService.listProduct(this.viewDetail.id, this.query).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
        this.loading = false;
        this.listProduct = res.items;
        this.statusProduct = res.businessStatus;
        this.total = res.totalElement;

        if (res.items.length === 0 && this.pageIndex > 1) {
          this.pageIndex = this.pageIndex - 1;
          this.loadData();

        }
      },
      err => {
        this.loading = false;
        this.notification.create(
          'error',
          'Thất bại',
          err
        );
      });

  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  setName(data) {
    const text = {
      label: 'Xóa sản phẩm',
      // tslint:disable-next-line:max-line-length
      value: '<p>Bạn có chắc chắn muốn xoá sản phẩm khỏi nhà phân phối <span class="colorDelete">' + data.name + '</span>?</p>'
    };

    this.modalDelete.showModal(text, data.id);

  }

  eventDelete(value) {
    const body = {
      body: {
        businessId: this.businessId,
        ids: value,
      }
    };
    this.distributorsService.removeProduct(body).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      if (res.code === 1) {
        this.notification.create(
          'success',
          'Thành công',
          'Xóa sản phẩm thành công'
        );
        this.mapOfCheckedId = {};
        this.ids = [];
        this.loadData(500);
        this.modalDelete.handleCancel();

      } else {
        this.notification.create(
          'warning',
          'Cảnh báo',
          res.message
        );
      }
      this.modalDelete.success();

    }, (err) => {
      this.notification.create(
        'error',
        'Thất bại',
        err
      );
      this.modalDelete.success();
    });
  }

  deleteProduct() {
    const text = {
      label: 'Xóa sản phẩm',
      // tslint:disable-next-line:max-line-length
      value: '<p>Bạn có chắc chắn muốn xoá danh sách sản phẩm khỏi nhà phân phối</p>'
    };

    this.modalDelete.showModal(text, this.ids);

  }

  search() {
    this.pageIndex = 1;
    this.loadData();
  }

  reset() {
    this.pageIndex = 1;
    this.name = undefined;
    this.titleId = undefined;
    this.loadData();
  }

  currentPageDataChange($event: ItemData[]): void {
    this.listOfDisplayData = $event;
    this.refreshStatus();
  }

  refreshStatus(data?): void {

    if (data) {
      const index = this.data.findIndex(z => z.id === data.id);
      index === -1 ? this.data.push({barcode: data.barCode, productId: data.id, name: data.name, titleId: data.titleId}) : this.data.splice(index, 1);

    }
    if (this.listOfDisplayData.length > 0) {
      this.isAllDisplayDataChecked = this.listOfDisplayData.every(item => this.mapOfCheckedId[item.id]);
    } else {
      this.isAllDisplayDataChecked = false;
    }
    this.isIndeterminate =
      this.listOfDisplayData.some(item => this.mapOfCheckedId[item.id]) && !this.isAllDisplayDataChecked;

    this.ids = [];
    for (const [key, value] of Object.entries(this.mapOfCheckedId)) {
      // tslint:disable-next-line:triple-equals
      if (value == true) {
        this.ids.push(key);
      }
    }
  }

  /*Check link image error*/
  checkImageErr(imageError) {
    this.imageFalse.push(imageError);
  }

  showImage(id: any, imageLink) {
    if (!this.imageFalse.includes(id)) {
      // @ts-ignore
      window.open(imageLink, '_blank');
    }
  }

  /*End Check link image error*/

  checkAll(value: boolean): void {
    this.listOfDisplayData.forEach(item => (this.mapOfCheckedId[item.id] = value));
    if (this.data.length === this.listOfDisplayData.length) {
      this.data = [];
      return;
    }
    this.data = this.listOfDisplayData.map(z => {
      return {productId: z.id, name: z.name, barcode: z.barCode, titleId: z.titleId};
    });

    this.refreshStatus();
  }


  actionsButton() {
    if (this.changeAction === '1') {
      this.addProduct();
    }
    if (this.changeAction === '2') {
      this.deleteProduct();
    }
    if (this.changeAction === '3') {
      this.exportExcel();
    }
  }

  addProduct() {
    if (this.statusProduct !== 1) {
      this.notification.create(
        'error',
        'Thất bại',
        'Nhà phân phối chưa được duyệt'
      );
      return;
    }

    this.assignProduct.showModal();
  }

  loadDataChild($event: any) {
    this.loadData(1000);
  }

  detailProduct(id: any, data?) {
    console.log(data);
    const query = {
      business_id: this.businessId,
      product_id: id
    };
    if (data) {
    }
    this.distributorsService.detailProduct(query).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.modal.showModal(res.data, id);

    });
  }

  exportExcel() {
    const query = {
      export_all: this.ids.length === 0,
      ids: this.ids.length !== 0 ? this.ids.toString() : '',
      name: this.name ? this.name.trim() : '',
      titleId: this.titleId ? this.titleId : '',
      id: this.viewDetail.id,
      page: this.pageIndex,
      pageSize: this.total
    };

    this.distributorsService.distributorsDetailExport(query).pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {
      this.rootService.export(data, `${this.viewDetail.name}.xlsx`);
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
